import React from 'react'
import PropTypes from 'prop-types'
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material'
import clsx from 'clsx'
import { withStyles } from '~/themes/useStyles'
import { COLORS } from '~/themes/common'

const style = (theme) => ({
  container: {},
  item: {
    display: 'flex',
    alignItems: 'flex-start',
    marginTop: theme.spacing(2),
    padding: theme.spacing(1, 1.5),
    borderRadius: theme.spacing(1),
    border: `1px solid ${COLORS.palette.primaryBlue}`,
    marginLeft: 0,
  },
  radio: {
    margin: '-9px 0 -9px -9px',
  },
  label: {
    width: '100%',
  },
})

const RadioButtonDetail = ({
  classes,
  className,
  value,
  onChange,
  options,
  radioProps,
  disabled,
  name,
}) => (
  <FormControl
    className={clsx(classes.container, className)}
    disabled={disabled}
  >
    <RadioGroup
      aria-label="gender"
      name={name}
      value={value}
      onChange={(e) => e.target.value !== value && onChange(e.target.value)}
    >
      {options.map((x) =>
        x?.hidden ? null : (
          <FormControlLabel
            classes={{
              label: classes.label,
            }}
            className={clsx('btn--Option', classes.item)}
            key={x.value}
            value={x.value}
            control={
              <Radio
                color="primary"
                className={classes.radio}
                disabled={x?.disabled}
                {...radioProps}
              />
            }
            label={x.label}
          />
        ),
      )}
    </RadioGroup>
  </FormControl>
)

RadioButtonDetail.defaultProps = {
  value: null,
  className: '',
  onChange: () => {},
  options: [],
  radioProps: {},
  disabled: false,
  name: 'gender1',
}

RadioButtonDetail.propTypes = {
  classes: PropTypes.shape().isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  options: PropTypes.arrayOf(PropTypes.shape()),
  radioProps: PropTypes.shape(),
  disabled: PropTypes.bool,
  name: PropTypes.string,
}

export default withStyles(style)(RadioButtonDetail)
